import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "footerFixed" };
const _hoisted_2 = {
    id: "all_wrapper",
    class: "fee_list"
};
const _hoisted_3 = { class: "wrapper_1" };
const _hoisted_4 = { class: "inner" };
const _hoisted_5 = { class: "nav_top" };
const _hoisted_6 = { class: "d_navi" };
const _hoisted_7 = { class: "year" };
const _hoisted_8 = { class: "fee_box" };
const _hoisted_9 = { class: "t_base" };
const _hoisted_10 = { key: 0 };
const _hoisted_11 = { key: 1 };
const _hoisted_12 = {
    key: 0,
    class: "pay"
};
const _hoisted_13 = {
    key: 0,
    class: "transfer-box"
};
const _hoisted_14 = { class: "transfer-row" };
const _hoisted_15 = { class: "transfer-amount" };
const _hoisted_16 = {
    key: 0,
    class: "transfer-row"
};
const _hoisted_17 = { class: "transfer-amount" };
const _hoisted_18 = { class: "transfer-row" };
const _hoisted_19 = { class: "transfer-amount" };
const _hoisted_20 = { class: "transfer-row transfer-row-total" };
const _hoisted_21 = { class: "transfer-amount" };
const _hoisted_22 = { class: "odd" };
const _hoisted_23 = { class: "sub_t" };
const _hoisted_24 = { class: "nav_under" };
const _hoisted_25 = { class: "d_navi" };
const _hoisted_26 = { class: "year" };
import { Link } from '@inertiajs/inertia-vue3';
import { Inertia } from '@inertiajs/inertia';
import headerVue from '@layout/header.vue';
import footerVue from '@layout/footer.vue';
import Formatter from '@util/Formatter';
export default /*@__PURE__*/ _defineComponent({
    __name: 'fee_list',
    props: {
        common: {},
        reward_history: {},
        transfer_group: {},
        year: {},
        untransfer_amount: {}
    },
    setup(__props) {
        const props = __props;
        const goReward = (step) => {
            const year = Number.parseInt(props.year);
            if (year === 1 && step === -1)
                return;
            if (Number.isNaN(year))
                return;
            Inertia.get(route('mentor.reward_history.index'), { year: year + step });
        };
        const showRank = (rank) => {
            if (rank)
                return rank;
            else {
                if (rank === null)
                    return '';
                if (rank === undefined)
                    return '';
            }
            return '';
        };
        const showUntransferAmount = () => {
            return `${props.untransfer_amount.toLocaleString()}円`;
        };
        const showPaidAmount = (payment_history_id) => {
            const targetGroup = props.transfer_group.find(item => item.payment_history_id === payment_history_id);
            if (targetGroup && targetGroup.withholding_tax_data) {
                return `${targetGroup.withholding_tax_data.final_payment_amount.toLocaleString()}円`;
            }
            // Fallback to old calculation if withholding tax data is not available
            let total = 0;
            if (targetGroup) {
                targetGroup.reward_ids.map((id) => {
                    var _a;
                    let targetHistory = props.reward_history.find(history => (history.id == id) && (history.is_pay == true));
                    if (targetHistory)
                        total += (_a = targetHistory.reward_amount) !== null && _a !== void 0 ? _a : 0;
                });
            }
            return `${total.toLocaleString()}円`;
        };
        const showPayedDate = (payment_history_id) => {
            const targetGroup = props.transfer_group.find(item => item.payment_history_id === payment_history_id);
            if (targetGroup) {
                return targetGroup.captured_date;
            }
            return '';
        };
        const getTransferBreakdown = (payment_history_id) => {
            const targetGroup = props.transfer_group.find(item => item.payment_history_id === payment_history_id);
            if (!targetGroup || !targetGroup.withholding_tax_data) {
                return null;
            }
            return targetGroup.withholding_tax_data;
        };
        const paidCount = () => { var _a, _b; return ((_b = (_a = props === null || props === void 0 ? void 0 : props.reward_history) === null || _a === void 0 ? void 0 : _a.filter((value) => value.is_pay)) !== null && _b !== void 0 ? _b : []).length; };
        //check the year is valid
        const validYear = Number.parseInt(props.year) && Number.parseInt(props.year) > 0;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", null, [
                _createVNode(headerVue, {
                    common: props.common
                }, null, 8, ["common"]),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _cache[24] || (_cache[24] = _createElementVNode("h2", null, "報酬履歴", -1)),
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("ul", _hoisted_6, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[0] || (_cache[0] = _withModifiers(($event) => (goReward(-1)), ["prevent"]))
                                            }, _cache[4] || (_cache[4] = [
                                                _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1)
                                            ]))
                                        ]),
                                        _createElementVNode("li", _hoisted_7, _toDisplayString(_unref(validYear) ? props.year : new Date().getFullYear()), 1),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[1] || (_cache[1] = _withModifiers(($event) => (goReward(1)), ["prevent"]))
                                            }, _cache[5] || (_cache[5] = [
                                                _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)
                                            ]))
                                        ])
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("table", _hoisted_9, [
                                        _cache[19] || (_cache[19] = _createElementVNode("thead", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, "相談終了日"),
                                                _createElementVNode("th", null, "振込日"),
                                                _createElementVNode("th", null, "件名"),
                                                _createElementVNode("th", null, "順位"),
                                                _createElementVNode("th", null, "報酬額"),
                                                _createElementVNode("th", null, "送金額")
                                            ])
                                        ], -1)),
                                        _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.reward_history, (history, index) => {
                                                var _a;
                                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                    _createElementVNode("tr", null, [
                                                        _createElementVNode("td", null, _toDisplayString(history.ended_at), 1),
                                                        _createElementVNode("td", null, _toDisplayString(showPayedDate(history.payment_history_id)), 1),
                                                        (history.question_id)
                                                            ? (_openBlock(), _createElementBlock("td", _hoisted_10, [
                                                                _createVNode(_unref(Link), {
                                                                    href: `/question/${history.question_id}`
                                                                }, {
                                                                    default: _withCtx(() => [
                                                                        _createTextVNode(_toDisplayString(history.subject), 1)
                                                                    ]),
                                                                    _: 2
                                                                }, 1032, ["href"])
                                                            ]))
                                                            : (_openBlock(), _createElementBlock("td", _hoisted_11, _toDisplayString(history.subject), 1)),
                                                        _createElementVNode("td", null, _toDisplayString(showRank(history.rank)), 1),
                                                        _createElementVNode("td", null, _toDisplayString(_unref(Formatter).formatAmount((_a = history.reward_amount) !== null && _a !== void 0 ? _a : null)), 1),
                                                        _cache[6] || (_cache[6] = _createElementVNode("td", null, null, -1))
                                                    ]),
                                                    (typeof history.payment_history_id === 'number')
                                                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                            ((props.reward_history[index + 1] &&
                                                                history.payment_history_id !==
                                                                    props.reward_history[index + 1].payment_history_id) ||
                                                                index + 1 === props.reward_history.length)
                                                                ? (_openBlock(), _createElementBlock("tr", _hoisted_12, [
                                                                    _cache[11] || (_cache[11] = _createElementVNode("td", null, null, -1)),
                                                                    _createElementVNode("td", null, _toDisplayString(showPayedDate(history.payment_history_id)), 1),
                                                                    _createElementVNode("td", null, [
                                                                        (getTransferBreakdown(history.payment_history_id))
                                                                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                                                                _createElementVNode("div", _hoisted_14, [
                                                                                    _cache[7] || (_cache[7] = _createElementVNode("span", { class: "transfer-label" }, "報酬額:", -1)),
                                                                                    _createElementVNode("span", _hoisted_15, _toDisplayString(getTransferBreakdown(history.payment_history_id).reward_before_fee.toLocaleString()) + "円", 1)
                                                                                ]),
                                                                                (getTransferBreakdown(history.payment_history_id).is_withholding_tax_subject)
                                                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                                                        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "transfer-label" }, "源泉徴収税額:", -1)),
                                                                                        _createElementVNode("span", _hoisted_17, "-" + _toDisplayString(getTransferBreakdown(history.payment_history_id).withholding_tax_amount.toLocaleString()) + "円", 1)
                                                                                    ]))
                                                                                    : _createCommentVNode("", true),
                                                                                _createElementVNode("div", _hoisted_18, [
                                                                                    _cache[9] || (_cache[9] = _createElementVNode("span", { class: "transfer-label" }, "振込手数料:", -1)),
                                                                                    _createElementVNode("span", _hoisted_19, "-" + _toDisplayString(getTransferBreakdown(history.payment_history_id).transfer_fee.toLocaleString()) + "円", 1)
                                                                                ]),
                                                                                _createElementVNode("div", _hoisted_20, [
                                                                                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "transfer-label" }, "送金額:", -1)),
                                                                                    _createElementVNode("span", _hoisted_21, _toDisplayString(getTransferBreakdown(history.payment_history_id).final_payment_amount.toLocaleString()) + "円", 1)
                                                                                ])
                                                                            ]))
                                                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                                                _createTextVNode(" 送金 (うち、振込手数料" + _toDisplayString(props.common.transfer_fee) + "円) ", 1)
                                                                            ], 64))
                                                                    ]),
                                                                    _cache[12] || (_cache[12] = _createElementVNode("td", null, null, -1)),
                                                                    _cache[13] || (_cache[13] = _createElementVNode("td", null, null, -1)),
                                                                    _createElementVNode("td", null, _toDisplayString(showPaidAmount(history.payment_history_id)), 1)
                                                                ]))
                                                                : _createCommentVNode("", true)
                                                        ], 64))
                                                        : _createCommentVNode("", true)
                                                ], 64));
                                            }), 256)),
                                            _createElementVNode("tr", _hoisted_22, [
                                                _cache[14] || (_cache[14] = _createElementVNode("td", null, null, -1)),
                                                _cache[15] || (_cache[15] = _createElementVNode("td", null, null, -1)),
                                                _cache[16] || (_cache[16] = _createElementVNode("td", null, "未送金残高", -1)),
                                                _cache[17] || (_cache[17] = _createElementVNode("td", null, null, -1)),
                                                _createElementVNode("td", null, _toDisplayString(showUntransferAmount()), 1),
                                                _cache[18] || (_cache[18] = _createElementVNode("td", null, null, -1))
                                            ])
                                        ])
                                    ])
                                ]),
                                _createElementVNode("p", _hoisted_23, [
                                    _cache[20] || (_cache[20] = _createTextVNode(" ※お振込み条件は、報酬残高の合計が5,000円以上で月末締め翌月末日払いです。")),
                                    _cache[21] || (_cache[21] = _createElementVNode("br", null, null, -1)),
                                    _createTextVNode("※振込手数料として" + _toDisplayString(_ctx.common.transfer_fee) + "円をお客様ご負担とさせて頂きます。 ", 1)
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("ul", _hoisted_25, [
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[2] || (_cache[2] = _withModifiers(($event) => (goReward(-1)), ["prevent"]))
                                            }, _cache[22] || (_cache[22] = [
                                                _createElementVNode("i", { class: "fas fa-angle-left" }, null, -1)
                                            ]))
                                        ]),
                                        _createElementVNode("li", _hoisted_26, _toDisplayString(_unref(validYear) ? props.year : new Date().getFullYear()), 1),
                                        _createElementVNode("li", null, [
                                            _createElementVNode("a", {
                                                onClick: _cache[3] || (_cache[3] = _withModifiers(($event) => (goReward(1)), ["prevent"]))
                                            }, _cache[23] || (_cache[23] = [
                                                _createElementVNode("i", { class: "fas fa-angle-right" }, null, -1)
                                            ]))
                                        ])
                                    ])
                                ])
                            ])
                        ])
                    ]),
                    _createVNode(footerVue)
                ])
            ]));
        };
    }
});
